/* Copyright (c) 2017 Backpack Health LLC */

const PublicRouteNames = {
  publicFile: (hash: any = ':hash', fileId: any = ':fileId') => `/public/${hash}/file/${fileId}`,
  publicShareCard: (hash: any = ':hash') => `/public/${hash}`,
  publicMedicalJewelryShareCard: (vendorName: any = ':vendorName', hash: any = ':hash') => `/public/${vendorName}/${hash}`,
  publicMedicalJewelryShareCardFile: (vendorName: any = ':vendorName', hash: any = ':hash', fileId: any = ':fileId') => `/public/${vendorName}/${hash}/file/${fileId}`,
  notFound: () => '/public/not-found',
  unsubscribe: (cuid: any = ':cuid') => `/public/settings/email/unsubscribe/${cuid}`,
  unsubscribeSuccess: () => '/public/settings/email/unsubscribe/success',
};

export default PublicRouteNames;
